export function WeeksBetweenDates(conception, feeding) {

  if (conception != 0) {

    const conceptionDateMillis = conception > 9_999_999_999 ? conception : conception * 1000;
    const feedingDateMillis = feeding > 9_999_999_999 ? feeding : feeding * 1000;

    const conceptionDate = new Date(conceptionDateMillis);
    conceptionDate.setHours(0, 0, 0, 0);

    const feedingDate = new Date(feedingDateMillis);
    feedingDate.setHours(0, 0, 0, 0);

    const diffMs = feedingDate.getTime() - conceptionDate.getTime();
    const ageInWeeks = diffMs / (1000 * 60 * 60 * 24 * 7);

    return ageInWeeks.toFixed(2);
  }
  return 0
}